import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import { checkInvAccess } from 'src/app/constants';
@Component({
  selector: 'delete-btn-cell-renderer',
  template: `
    <span class="detailiconhome">
      <img
        class="detailiconhome"
        *ngIf="addEditShifts"
        src="assets/images/icon-delete.svg"
        title="delete"
        alt="Delete"
        style="width=20px;height=20px"
        (click)="btnClickedHandler($event)"
      />
    </span>
  `,
})
export class DeleteBtnCellRender implements ICellRendererAngularComp {
  pageName: any;
  detailPage: any;
  deleteFlag: boolean = false;
  deleteBtn: any;
  disabled: boolean = false;
  access;
  access1;
  addEditShifts: any;

  constructor(private router: Router, private route: ActivatedRoute) {}
  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  private params: any;
  agInit(params: any): void {
    this.access = checkInvAccess();
    this.addEditShifts = this.access?.functionalityAccess?.addEditShifts || false;
    // this.access = JSON.parse(localStorage.getItem('shiftAccess1'));
    // this.access1 = JSON.parse(localStorage.getItem('shiftAccess2'));
    console.log('access', this.access, this.access1);

    this.params = params;
  }
  btnClickedHandler(event: any) {
    this.params.clicked(this.params.data);
  }
}
